import products from "@/assets/json/products.js";
import Cookies from "js-cookie";
import Vue from "vue";


export default {
	getUrlParam(name) {
		var query = window.location.search.substring(1); // Remove question mark
		var parameters = query.split("&");

		for (var i = 0; i < parameters.length; i++) {
			var pair = parameters[i].split("=");

			if (pair[0] == name) {
				return pair[1];
			}
		}

		return null;
	},
	openWindowWithPost(url, params) {
		var form = document.createElement("form");
		form.setAttribute("method", "post");
		form.setAttribute("action", url);
		// form.setAttribute("target", name);

		for (var i in params) {
			if (params.hasOwnProperty(i)) {
				var input = document.createElement("input");
				input.type = "hidden";
				input.name = i;
				input.value = params[i];
				form.appendChild(input);
			}
		}

		document.body.appendChild(form);

		//note I am using a post.htm page since I did not want to make double request to
		//the page it might have some Page_Load call which might screw things up.
		// window.open("post.htm");

		form.submit();

		document.body.removeChild(form);
	},
	getProductName(productId) {
		// var cards = JSON.parse(localStorage.getItem("jsonFile")).cards;
		for (var index in products) {
			var product = products[index];
			if (product.card === productId || product.paper === productId) {
				return product.name;
			}
		}
		return "";
	},
	getCompanyProductName(productId, productList) {
		for (var index in productList) {
			var product = productList[index];
			if (product.card === productId || product.paper === productId) {
				return product.name;
			}
		}
		return "";
	},
	getProductById(productId, productList) {
		for (var index in productList) {
			var product = productList[index];
			if (
				product.card + "" === productId + "" ||
				product.paper + "" === productId + ""
			) {
				return product;
			}
		}
		return "";
	},
	getProductByBrand(brand, productList) {
		for (var index in productList) {
			var product = productList[index];
			if (product.brand === brand) {
				return product;
			}
		}
		return "";
	},
	getProductByIdAndBrand(productId, brand, productList) {
		for (var index in productList) {
			var product = productList[index];
			if (
				(product.card + "" === productId + "" ||
					product.paper + "" === productId + "") &&
				product.brand === brand
			) {
				return product;
			}
		}
		return "";
	},
	getCustomerDisplayProducts(customerProductList) {
		let customerProducts = [];
		for (var index in customerProductList) {
			if (customerProductList[index].card !== 13 && customerProductList[index].paper !== 2){
				customerProducts.push(customerProductList[index]);
			}
		}
		return customerProducts;
	},
	selectColorStatus(status) {
		switch (status) {
			case "A":
			case "Z":
				return "background-expired";
			case "V":
				return "background-active";
			case "S":
				return "background-blocked";
			case "N":
			case "P":
				return "background-will-expire";
			case "PR":
			case "PV":
				return "background-production";

			default:
				return "background-inactive";
		}
	},
	base64ToArrayBuffer(base64) {
		var binaryString = window.atob(base64);
		var binaryLen = binaryString.length;
		var bytes = new Uint8Array(binaryLen);
		for (var i = 0; i < binaryLen; i++) {
			var ascii = binaryString.charCodeAt(i);
			bytes[i] = ascii;
		}
		return bytes;
	},
	arrayBufferToBase64(buffer) {
		var binary = "";
		var bytes = new Uint8Array(buffer);
		var len = bytes.byteLength;
		for (var i = 0; i < len; i++) {
			binary += String.fromCharCode(bytes[i]);
		}
		return window.btoa(binary);
	},
	logout() {
		Cookies.remove("userLink");
		Cookies.remove("token");

		localStorage.removeItem("selectedCompany");
		localStorage.removeItem("customer_data");
		localStorage.removeItem("user_data");

		sessionStorage.removeItem("selectedCompany");
		sessionStorage.removeItem("customer_data");
		sessionStorage.removeItem("user_data");
		// sessionStorage.removeItem("user_link");
		
		if (process.env.NODE_ENV === "production") {
			window.open("https://go.uphellas.gr/#/main", "_self");
		} else {
			window.open("https://dev-auth.uphellas.gr/", "_self");
			
			// Vue.$keycloak.logout();
		}
	},
};
